(function () {
    'use strict';
    angular.module('SMART2').directive('smartList', ['$parse', '$window', 'commonUtilities', function ($parse, $window, commonUtilities) {
        return {
            restrict: 'AE',
            replace: false,
            scope: true,
            link: function (scope, element, attrs) {
                scope.styleClass = 'collection';
                scope.itemClass = 'collection-item';
                // evaluating callback for list
                var clickCallback = $parse(attrs.clickCallback);

                attrs.$observe('selectiveDisplayConfig', function (displayConfig) {
                    if (displayConfig) {
                        scope.listDisplayConfig = scope.$eval(displayConfig);
                    } else {
                        scope.listDisplayConfig = { "showIcon": true, "showAction": false, "importantAttribLimit": 5 };
                    }

                });

                //Loacal list Click handler
                scope.listClickHandler = function (item) {
                    if (angular.isFunction(clickCallback)) {
                        clickCallback(scope, { e: item });
                    }
                };

                attrs.$observe("height", function (value) {
                    if (value) {
                        scope.listHeight = value;
                    }
                });

                attrs.$observe('model', function (value) {
                    if (value) {
                        scope.dataModel = scope.$eval(value);
                    }
                });


                attrs.$observe('styleClass', function (value) {
                    scope.styleClass = value;
                });

                attrs.$observe('itemClass', function (value) {
                    scope.itemClass = value;
                });

                attrs.$observe('template', function (value) {
                    scope.template = value;
                });
                var lazyLoadingCallback = $parse(attrs.lazyLoadCallback);
                var backToTopCallback = $parse(attrs.backToTopCallback);
                var scrolledCallback = $parse(attrs.scrollInProgress);

                scope.scrollEndCallback = function () {
                    if (angular.isFunction(lazyLoadingCallback)) {
                        lazyLoadingCallback(scope, { e: '' });
                    };
                };

                scope.scrollToTopCallback = function () {
                    if (angular.isFunction(backToTopCallback)) {
                        backToTopCallback(scope, { e: '' });
                    };
                };

                scope.scrollInProgress = function () {
                    if (angular.isFunction(scrolledCallback)) {
                        scrolledCallback(scope, { e: '' });
                    };
                };

                scope.actionElementID = commonUtilities.uniqueIDGenerator;

            },
            templateUrl: 'shared/directives/uiElements/smartList/smartListTemplate.html'
        };
    }]);
})();